import { actionTypes } from '../../../types';

export const viewUGCContentforInfluencer = (payload, callback) => ({
    type: actionTypes.VIEW_UGC_CONTENT_FOR_INFLUENCER_REQUEST,
    payload,
    callback
});

export const viewUGCContentforInfluencerSuccess = (payload) => ({
    type: actionTypes.VIEW_UGC_CONTENT_FOR_INFLUENCER_SUCCESS,
    payload,
});

export const viewUGCContentforInfluencerFailure = (payload) => ({
    type: actionTypes.VIEW_UGC_CONTENT_FOR_INFLUENCER_FAILURE,
    payload,
});

export const viewUGCContentforInfluencerReset = () => ({
    type: actionTypes.VIEW_UGC_CONTENT_FOR_INFLUENCER_RESET,
});

export const viewUGCContentforInfluencerResetAll = () => ({
    type: actionTypes.VIEW_UGC_CONTENT_FOR_INFLUENCER_RESET_ALL,
});
